import React from 'react';
import DillardsLogo from './svgs/DillardsLogo';
import CloseIcon from './svgs/CloseIcon';
import FeedbackQuestionOptions from './FeedbackQuestionOptions';

const FeedbackForm = ({
  handleResetModal,
  hover,
  handleHover,
  selectedExp,
  selectedState,
  handleSelectedExp,
  templateTypes,
  selectedTemplate,
  handleSelectState,
  loading,
  error,
  errorMessage,
  handleSubmitFeedback,
  handleInput,
  handleBlur,
  handleSelectYoN,
  submitSuccess,
  attemptedSubmit,
  siteFormat,
  answersObj,
}) => {
  return (
    <div id={`feedback_form_content`} className={`${siteFormat === 'mobile' && 'mobile'} row mx-0`}>
      <CloseIcon handleResetModal={handleResetModal} siteFormat={siteFormat} />
      {submitSuccess ? (
        <>
          <div id='feedback_success_content'>
            <div id='feedback_success_title'>Thank you!</div>
            <div id='feedback_success_message'>
              We appreciate you taking the time to help make your shopping experience the best it can be.
            </div>
            <button className='btn btn-primary btn-block' id='feedback_submit' onClick={() => handleResetModal()}>
              Continue Shopping
            </button>
          </div>
        </>
      ) : (
        <>
          <div id='feedback_form_header'>
            <DillardsLogo />
          </div>
          <div id='feedback_form_body' className='col-12'>
            {loading ? (
              <div id='loading_spinner_holder'>
                <div id='feedback_loading_spinner'></div>
              </div>
            ) : error ? (
              <div id='feedback_error_message'>{errorMessage}</div>
            ) : (
              <>
                <form>
                  <section id='feedback_select_type_section' className='form-group'>
                    <div className='feedback_input'>
                      <p>What would you like to tell us about?</p>
                      <select
                        className='feedback_select_input form-control'
                        onChange={(e) => {
                          handleSelectedExp(e.target.value);
                        }}
                        value={selectedExp}
                      >
                        <option key='default' value='default' id='selectOption'>
                          Please Select an Option
                        </option>
                        {templateTypes.length > 0 &&
                          templateTypes.map((a) => {
                            return (
                              <option key={a.templateId} value={a.templateId} id={a.templateId}>
                                {a.name}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                  </section>
                  <div id='feedback-answers-section'>
                    {selectedTemplate &&
                      selectedTemplate.questions.map((qst) => {
                        return (
                          <FeedbackQuestionOptions
                            key={qst.questionId}
                            id={qst.questionId}
                            type={qst.type}
                            text={qst.text}
                            handleHover={handleHover}
                            hover={hover}
                            selectedState={selectedState}
                            handleSelectState={handleSelectState}
                            storeList={qst.storeList ? qst.storeList : undefined}
                            required={qst.required}
                            handleInput={handleInput}
                            handleBlur={handleBlur}
                            handleSelectYoN={handleSelectYoN}
                            attemptedSubmit={attemptedSubmit}
                            siteFormat={siteFormat}
                            answersObj={answersObj}
                            options={qst?.questionOptions ? qst.questionOptions : undefined}
                          />
                        );
                      })}
                  </div>
                  {selectedTemplate ? (
                    <div id='feedback_buttons_section'>
                      <button className='btn btn-secondary btn-block' onClick={() => handleResetModal()}>
                        cancel
                      </button>
                      <button
                        className='btn btn-primary btn-block'
                        id='feedback_submit'
                        onClick={(e) => handleSubmitFeedback(e)}
                      >
                        submit
                      </button>
                    </div>
                  ) : (
                    ''
                  )}
                </form>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default FeedbackForm;
